/**
 * Vrai uniquement quand la donnée HYBRIDE_RECHARGEABLE est cochée sur l'annonce.
 * `non` et l'absence de valeur ne comptent pas.
 */
export function hasHybrideRechargeable (post) {
  const value = post && post.hybride_rechargeable
  return value === true || value === 'oui'
}

/**
 * Retire le mot hybride déjà porté par l'énergie.
 * « hybride rechargeable » → « Rechargeable », « plug-in hybrid » → « Plug-in ».
 */
export function shortHybrideRechargeableLabel (label) {
  const source = String(label == null ? '' : label).trim()
  if (!source) return ''

  const stripped = source
    .replace(/hybrides?|hybrids?|h[ií]bridos?/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  const text = stripped || source

  return text.charAt(0).toUpperCase() + text.slice(1)
}
